import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class ResourceClinicDataService {

  constructor(private httpClient: ApiHttpClient) {
  }

  public deleteAsync(id: number | string, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ResourceClinics/Delete', id, timeout);
  }
}
